var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.AllOrdersHistory.Messages.GetOrderItems, Vendd.AllOrdersHistory, function (envelope) {
        var options = {
            url: 'api/AllOrdersItemsHistory/GetOrderItems',
            data: {
                orderCode: envelope.message.data,
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.AllOrdersHistory.Messages.GetOrderItemsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.AllOrdersHistory.Messages.GetOrderItemsFailure(response));
        }

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});
